var React = require('react');

function YoutubeIcon (props) {
    return React.createElement("svg",props,[React.createElement("mask",{"id":"a","fill":"#fff","key":0},React.createElement("path",{"d":"m.00011745.0004h20.07788255v14.038h-20.07788255z","fill":"#fff","fillRule":"evenodd"})),React.createElement("path",{"d":"m8.0198 9.6121v-5.627c2 .939 3.548 1.848 5.381 2.827-1.511.837-3.381 1.776-5.381 2.8m11.146-8.426c-.345-.454-.933-.806-1.56-.924-1.839-.349-13.318-.35-15.157 0-.502.094-.949.321-1.333.674-1.618 1.5-1.111 9.544-.721 10.847.165.564.376.972.643 1.238.344.353.815.596 1.356.705 1.515.313 9.32.488 15.181.048.54-.095 1.018-.346 1.395-.714 1.496-1.494 1.394-9.99.196-11.874","fill":"#151e2d","fillRule":"evenodd","mask":"url(#a)","key":1})]);
}

YoutubeIcon.defaultProps = {"height":"15","viewBox":"0 0 21 15","width":"21"};

module.exports = YoutubeIcon;

YoutubeIcon.default = YoutubeIcon;
